<mat-card class="mwr-5" tabindex="0" *ngIf="showCard">
  <mat-card-header class="ds-fl">
    <img
      src="{{ cdnHost }}/img/ceramicQuackalsAnimated.gif"
      alt="Ceramic Quackals"
      class="ceramic-quackals"
    />
    <button
      mat-icon-button
      aria-label="Dismiss ceramic upgrade card"
      class="close-btn"
      (click)="handleDismissCard()"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="handleDismissCard()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="fld-col ceramic-content">
    <span class="fls-1-1"></span>
    <mat-card-title class="ta-c">
      <div>Introducing</div>
      <img
        src="{{ cdnHost }}/img/ceramicDuckTextAnimated.gif"
        alt="Ceramic Duck Gif"
        class="ceramic-gif"
      />
    </mat-card-title>
    <mat-card-content>
      <p class="fs-u0 ceramic-content">
        An experience unlike any other. With consistent use, provide
        unparalleled protection and look spectacular!
      </p>
      <div *ngIf="showPromo" class="promo pwy-4">
        Upgrade your membership and we'll waive your upgrade fees!
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button
        myqq-button
        color="primary"
        class="raised upgrade-btn"
        aria-label="Upgrade Now"
        (click)="upgrade.emit()"
        (keydown.enter)="$event.preventDefault()"
        (keyup.enter)="upgrade.emit()"
      >
        Upgrade Now
      </button>
    </mat-card-actions>
  </div>
</mat-card>
